import { useUsersAccessCreateTechnician } from '../../hooks/useUsersAccessCreateTechnician'
import { useTranslation } from 'react-i18next'

import { Alert, Modal, Skeleton, Stack } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { UsersAccessTechnicianForm } from './UsersAccessTechnicianForm'

interface CreateUsersAccessTechnicianModalIProps {
  colorScheme: ColorScheme
  isOpen: boolean
  onClose: () => void
}

export const CreateUsersAccessTechnicianModal = ({
  colorScheme,
  isOpen,
  onClose,
}: CreateUsersAccessTechnicianModalIProps) => {
  const { t } = useTranslation()
  const {
    canCreate,
    errors,
    facilityOptions,
    isError,
    isLoading,
    isSaving,
    setFacilitySearch,
    setField,
    submit,
    values,
  } = useUsersAccessCreateTechnician(colorScheme)

  const save = async () => {
    const didSave = await submit()
    if (didSave) onClose()
  }

  return (
    <Modal
      bodyStyleOverrides={{ minH: 0, overflowY: 'auto' }}
      closeOnEsc={!isSaving}
      closeOnOverlayClick={!isSaving}
      colorScheme={colorScheme}
      isCloseHidden={isSaving}
      isOpen={isOpen}
      isSaveDisabled={isLoading || isError || !canCreate}
      isSaveLoading={isSaving}
      maxW='600px'
      onClose={onClose}
      onSave={save}
      saveButtonLabel={t('settings:rebrand_users_create_technician_submit')}
      showCancelButton={!isSaving}
      size='compact'
      title={t('settings:rebrand_users_create_technician_title')}
    >
      {isLoading ? (
        <Stack gap='16px'>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton h='52px' key={index} w='full' />
          ))}
        </Stack>
      ) : isError ? (
        <Alert
          colorScheme={colorScheme}
          description={t('settings:rebrand_users_facilities_load_error')}
          variant='error'
        />
      ) : (
        <UsersAccessTechnicianForm
          colorScheme={colorScheme}
          errors={errors}
          facilityOptions={facilityOptions}
          onFacilitySearchChange={setFacilitySearch}
          setField={setField}
          testIdPrefix='CreateUsersAccessTechnicianModal'
          values={values}
        />
      )}
    </Modal>
  )
}
